import { callCareersApi } from "./careers-api";

export const listarPosicionesPublicas = async () => callCareersApi<any[]>("/posiciones");

export const obtenerPosicionPublica = async (data: { id: string }) =>
  callCareersApi<any>(`/posiciones/${data.id}`);

export const listarPosicionesAdmin = async () => callCareersApi<any[]>("/admin/posiciones");

export const obtenerPosicionAdmin = async (data: { id: string }) =>
  callCareersApi<any>(`/admin/posiciones/${data.id}`);

export type EntradaPosicion = {
  id?: string;
  nombre: string;
  area: string;
  subarea: string | null;
  turno: string;
  horario: string;
  tipo_jornada: string;
  vacantes: number;
  objetivo: string;
  descripcion: string;
  actividades: string[];
  perfil: string;
  escolaridad: string;
  experiencia: string;
  conocimientos: string[];
  competencias: string[];
  documentos_indispensables: string[];
  reporta_a: string;
  fecha_limite: string | null;
  rango_salarial: string | null;
  comentarios: string | null;
  estatus: "borrador" | "publicada" | "pausada" | "cerrada";
};

export const guardarPosicion = async (data: EntradaPosicion) => {
  const { id, ...campos } = data;
  if (id) {
    return callCareersApi<{ id: string }>(`/admin/posiciones/${id}`, {
      method: "PUT",
      body: JSON.stringify(campos),
    });
  }

  return callCareersApi<{ id: string }>("/admin/posiciones", {
    method: "POST",
    body: JSON.stringify(campos),
  });
};

export const cambiarEstatusPosicion = async (data: {
  id: string;
  estatus: "borrador" | "publicada" | "pausada" | "cerrada";
}) =>
  callCareersApi<{ ok: true }>(`/admin/posiciones/${data.id}/estatus`, {
    method: "POST",
    body: JSON.stringify({ estatus: data.estatus }),
  });

export const duplicarPosicion = async (data: { id: string }) =>
  callCareersApi<{ id: string }>(`/admin/posiciones/${data.id}/duplicar`, {
    method: "POST",
    body: JSON.stringify({}),
  });
